import React, { useState} from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { useMutation } from '@apollo/client';
import { DELETE_TENANT_BY_TENANT_ID } from 'graphql/service';
import { Container } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalRemoveTenant = ({
  buttonLabel,
  buttonStyle,
  name,
  tenantId
}) => {

  const [isOpen, setIsOpen] = useState(false);

  const [deleteTenant, {loading}] = useMutation(DELETE_TENANT_BY_TENANT_ID,
    {
      onCompleted: (data) => {
        if(data.deleteTenant.id) {
          setIsOpen(false)
        } else {
          const content = 'Remove tenant failed!'
          debouncedErrorMessage(content);
        }
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  )

  const handleRemove = () => {
    if(loading) return
    deleteTenant({
      variables: {
        tenantId
      }
    })
  }

  return (
    <MainModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      buttonLabel={buttonLabel}
      buttonStyle={buttonStyle}
      danger={true}
      className="modal-danger"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <div className='text'>{`Are you sure you want to remove ${name} from the tenant list?`}</div>
        <div className='buttonContainer'>
          <Button
            danger
            onClick={() => setIsOpen(false)}
            additionalstyle={`
              width: 79px;
            `} 
          >
            Cancel
          </Button>
          <Button
            success
            onClick={handleRemove}
            data-loading={loading}
            additionalstyle={`
              width: 56px;
            `}
          >
            {loading? null: 'Yes'}
          </Button>
        </div>
      </Container>
    </MainModal>
  );
}

export default ModalRemoveTenant;
